import { hooks } from '@bigcommerce/stencil-utils';
import CatalogPage from './catalog';
import compareProducts from './global/compare-products';
import FacetedSearch from './common/faceted-search';
import { createTranslationDictionary } from '../theme/common/utils/translations-utils';
import utils from '@bigcommerce/stencil-utils';
import urlUtils from './common/utils/url-utils';
import Url from 'url';
import { bind, debounce, isEmpty } from 'lodash';

export default class Category extends CatalogPage {
    constructor(context) {
        super(context);
        this.validationDictionary = createTranslationDictionary(context);
    }

    setLiveRegionAttributes($element, roleType, ariaLiveStatus) {
        $element.attr({
            role: roleType,
            'aria-live': ariaLiveStatus,
        });
    }

    makeShopByPriceFilterAccessible() {
        if (!$('[data-shop-by-price]').length) return;

        if ($('.navList-action').hasClass('is-active')) {
            $('a.navList-action.is-active').focus();
        }

        $('a.navList-action').on('click', () => this.setLiveRegionAttributes($('span.price-filter-message'), 'status', 'assertive'));
    }

    onReady() {
        this.listingProductQtyChange();

        this.arrangeFocusOnSortBy();

        $('[data-button-type="add-cart"]').on('click', (e) => this.setLiveRegionAttributes($(e.currentTarget).next(), 'status', 'polite'));

        this.makeShopByPriceFilterAccessible();

        compareProducts(this.context);

        if ($('#facetedSearch').length > 0) {
            this.initFacetedSearch();
        } else {
            this.onSortBySubmit = this.onSortBySubmit.bind(this);
            hooks.on('sortBy-submitted', this.onSortBySubmit);
        }

        $('a.reset-btn').on('click', () => this.setLiveRegionsAttributes($('span.reset-message'), 'status', 'polite'));

        this.ariaNotifyNoProducts();
        this.disableCanadaAddtocart();
        this.listingModeSwitch();

        $('.category-header-image').insertBefore('#main-content > .container');
    }

    ariaNotifyNoProducts() {
        const $noProductsMessage = $('[data-no-products-notification]');
        if ($noProductsMessage.length) {
            $noProductsMessage.focus();
        }
    }

    initFacetedSearch() {
        const {
            price_min_evaluation: onMinPriceError,
            price_max_evaluation: onMaxPriceError,
            price_min_not_entered: minPriceNotEntered,
            price_max_not_entered: maxPriceNotEntered,
            price_invalid_value: onInvalidPrice,
        } = this.validationDictionary;
        const $productListingContainer = $('#product-listing-container');
        const $facetedSearchContainer = $('#faceted-search-container');
        const productsPerPage = this.context.categoryProductsPerPage;
        const requestOptions = {
            config: {
                category: {
                    shop_by_price: true,
                    products: {
                        limit: productsPerPage,
                    },
                },
            },
            template: {
                productListing: 'category/product-listing',
                sidebar: 'category/sidebar',
            },
            showMore: 'category/show-more',
        };

        this.facetedSearch = new FacetedSearch(requestOptions, (content) => {
            $productListingContainer.html(content.productListing);
            $facetedSearchContainer.html(content.sidebar);

            $('body').triggerHandler('compareReset');

            // callback function after click on pagination and filters
            this.listingProductQtyChange();
            this.disableCanadaAddtocart();
            this.listingModeSwitch();
            $('.category-header-image').insertBefore('#main-content > .container');

            $('html, body').animate({
                scrollTop: 0,
            }, 100);
        }, {
            validationErrorMessages: {
                onMinPriceError,
                onMaxPriceError,
                minPriceNotEntered,
                maxPriceNotEntered,
                onInvalidPrice,
            },
        });
    }

    disableCanadaAddtocart() {
        const currentCurrency = this.context.currency_selector.active_currency_code;
        $('.productGrid .product, .productList .product').each((i, e) => {
            const id = +$(e).find('button.add-to-cart').data('product-id');
            if (id) {
                fetch('/graphql', {
                    method: 'POST',
                    credentials: 'same-origin',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer ' + this.context.settings.storefront_api.token
                    },
                    body: JSON.stringify({
                        query: `
                        query getIdBySku {
                            site {
                            product (entityId: ` + id + `) {
                                sku
                                warranty
                            }
                          }
                        }
                        `
                    }),
                })
                .then(res => res.json())
                .then(json => {
                    const warranty = json.data.site.product.warranty;
                    if (warranty && !isEmpty(warranty)) {
                        const warrantyArray = JSON.parse(warranty);
                        if ("notAvailableInCanada" in warrantyArray) {
                            // remove add to cart if product is disabled in canada and currency is CAD
                            if (warrantyArray["notAvailableInCanada"] == true) {
                                $(e).find('.card-text').append('<div class="not-available-canada">Not available in Canada</div>');
                                if (currentCurrency == "CAD") {
                                    $(e).find('.product-actions, .listItem-actions').remove();
                                }
                            }
                        } else if ("addToCartOverride" in warrantyArray) {
                            // override add to cart
                            if (warrantyArray["addToCartOverride"] && !isEmpty(warrantyArray["addToCartOverride"])) {
                                const overrideButton = $(`<button type='button' class='button add-to-cart' style='padding: 1rem 10px; width: 100%;' data-reveal-id='addtocart-override-modal-${id}'>`).text(warrantyArray["addToCartOverride"]["buttonLabel"]);
                                const overrideAddtocartModal = '<div class="add-to-cart-override-message modal modal--small" id="addtocart-override-modal-' + id + '" data-reveal>\
                                    <a href="#" class="modal-close" role="button"><span aria-hidden="true">×</span></a>'
                                    + warrantyArray["addToCartOverride"]["messageContent"] +
                                '</div>';
                                $(e).find('.product-actions, .listItem-actions').empty().append(overrideButton).append(overrideAddtocartModal);
                            } else {
                                $(e).find('.product-actions, .listItem-actions').remove();
                            }
                        }
                    }
                })
            }
        })
    }

    listingModeSwitch() {
        const listingGrid = $('.product-listing-wrapper-grid');
        const listingList = $('.product-listing-wrapper-list');
        $('.switcher .button').click(e => {
            let mode = $(event.currentTarget).data('value');

            if (mode == 'grid') {
                $(listingGrid).show();
                $(listingList).hide();
                $('.switcher .button.grid').addClass('active');
                $('.switcher .button.list').removeClass('active');
            }
            if (mode == 'list') {
                $(listingGrid).hide();
                $(listingList).show();
                $('.switcher .button.grid').removeClass('active');
                $('.switcher .button.list').addClass('active');
            }
        })
    }

    listingProductQtyChange() {
        $('.listing-addtocart-qty').on('change', event => {
            let qty = $(event.currentTarget).val();
            let productId = $(event.currentTarget).data('product-id');
            if (isNaN(qty) || qty <= 0) {
                qty = 1;
            }

            const linkHtml = $(event.currentTarget).next('.add-to-cart');
            let jsFunc = `addToCartById(${productId}, ${qty})`;
            $(linkHtml).attr('onclick', jsFunc);
        })
    }
}
